module.exports = __webpack_public_path__ + "static/img/card1.446e9209.png";